// constants/timeline.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 16:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// Timeline constants: event categories and blank event template.

export const TIMELINE_CATEGORIES = {
  prewar:     { label: 'Pre-war',    color: '#3b82f6', bg: '#3b82f615' },
  war:        { label: 'Occupation', color: '#f59e0b', bg: '#f59e0b15' },
  camp:       { label: 'Camp',       color: '#ef4444', bg: '#ef444415' },
  liberation: { label: 'Liberation', color: '#34c759', bg: '#34c75915' },
  postwar:    { label: 'Post-war',   color: '#8b5cf6', bg: '#8b5cf615' },
  family:     { label: 'Family',     color: '#ec4899', bg: '#ec489915' },
  other:      { label: 'Other',      color: '#6b7280', bg: '#6b728015' },
};

// Names the AI writes that mean an existing category. The key for Occupation is
// "war", so an event saved as "occupation" (or "ghetto") matched no category at
// all: it drew grey as Other and appeared under no filter pill, which is why the
// pill counts did not add up to the total.
const CATEGORY_ALIASES = {
  occupation: 'war',
  ghetto:     'war',
  war_time:   'war',
  'pre-war':  'prewar',
  'post-war': 'postwar',
  liberated:  'liberation',
};

/** Canonical category key for an event, tolerating the aliases above. */
export function resolveCategory(raw) {
  const key = String(raw || '').trim().toLowerCase().replace(/\s+/g, '_');
  if (TIMELINE_CATEGORIES[key]) return key;
  return CATEGORY_ALIASES[key] || 'other';
}

export const BLANK_EVENT = {
  year:         '',
  title:        '',
  description:  '',
  category:     'other',
  location:     '',
  source_quote: '',
  verified:     false,
};
